/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Axios, { AxiosRequestConfig } from "axios";

const axios = Axios.create();

axios.interceptors.request.use((req) => {
  req.baseURL = process.env.VUE_APP_SALUTARIA_API_URL + "/api/faq";
  req.headers!.authorization = `Bearer ${localStorage.authToken}`;
  // req.headers.origin = process.env.BASE_URL;
  return req;
});
export default {
  getListTags() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/tags",
    };
    return axios(options);
  },
  getListFaq() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/list",
    };
    return axios(options);
  },
};
